import { render } from "./TheToastMessage.vue?vue&type=template&id=0b16494b&ts=true"
import script from "./TheToastMessage.vue?vue&type=script&lang=ts"
export * from "./TheToastMessage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__